module.exports = __webpack_public_path__ + "src/assets/img/google/google-gsuite-logo-horizontal.10fa74960be83c75b3cfbf56c5d0c513.png";